import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import type { FC } from "react";

interface OAuthProviderButtonProps {
  label: string;
  onClick: () => void;
}

/**
 * Secondary buttons for the Google / Microsoft OAuth providers, shared by the
 * sign-in screen and the account-resolution screens.
 */
export const GoogleSignInButton: FC<OAuthProviderButtonProps> = ({
  label,
  onClick,
}) => (
  <Button className="w-52" onClick={onClick} variant={ButtonVariant.Secondary}>
    <div className="grid grid-cols-[auto_1fr] justify-center gap-2">
      <svg
        className="size-5" // Adjust the size as needed
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Google logo</title>
        <clipPath id="g">
          <path d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z" />
        </clipPath>
        <g clipPath="url(#g)">
          <path fill="#FBBC05" d="M0 37V11l17 13z" />
          <path fill="#EA4335" d="M0 11l17 13 7-6.1L48 14V0H0z" />
          <path fill="#34A853" d="M0 37l30-23 7.9 1L48 0v48H0z" />
          <path fill="#4285F4" d="M48 48L17 24l-4-3 35-10z" />
        </g>
      </svg>
      <span>{label}</span>
    </div>
  </Button>
);

export const MicrosoftSignInButton: FC<OAuthProviderButtonProps> = ({
  label,
  onClick,
}) => (
  <Button className="w-52" onClick={onClick} variant={ButtonVariant.Secondary}>
    <div className="grid grid-cols-[auto_1fr] justify-center gap-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="size-5"
        viewBox="0 0 23 23"
      >
        <path fill="#f35325" d="M0 0h10v10H0z" />
        <path fill="#81bc06" d="M11 0h10v10H11z" />
        <path fill="#05a6f0" d="M0 11h10v10H0z" />
        <path fill="#ffba08" d="M11 11h10v10H11z" />
      </svg>
      <span>{label}</span>
    </div>
  </Button>
);
